//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../../../lib/date';
import fileUploader from '../../../common-components/file-uploader';

export default {
    name: 'return-visit-view',
    components: {
        fileUploader
    },
    props: {
        workOrderId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            returnVisitDto: {
                file: {}
            },
            saving: false,
            rules: {
                name: [{ required: true, message: '请输入回访联系人', trigger: 'blur' }],
                mobile: [{ required: true, message: '请输入回访电话', trigger: 'blur' }],
                content: [{ required: true, message: '请输入回访内容', trigger: 'blur' }],
                score: [{ required: true, type: 'number', message: '请选择客户满意度', trigger: 'change' }]
            },
            returnVisits: [],
            showReturnVisitModel: false,
            tuiDanNum: 0
        };
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        }
    },
    methods: {
        visibleChange(value) {
            if (!value) {
                this.$emit('input', value);
            }
        },
        cancel() {
            this.$refs.returnVisitForm.resetFields();
            this.$emit('input', false);
            this.showReturnVisitModel = false;
        },
        onSaveReturnVisit() {
            var vm = this;
            vm.returnVisitDto.workOrderId = this.workOrderId;
            this.$refs.returnVisitForm.validate(async (val) => {
                if (val) {
                    // console.log(vm.returnVisitDto);
                    vm.saving = true;
                    abp.ajax.post('/api/services/app/WorkOrder/SaveReturnVisit', vm.returnVisitDto).then(() => {
                        vm.showReturnVisitModel = false;
                        vm.$emit('saveSuccess');
                        vm.$emit('onRefreshOperationLog');
                        vm.getReturnVisits();
                        this.showReturnVisitModel = false;
                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
        },
        scoreClear() {
            this.returnVisitDto.score = null;
        },
        getReturnVisits() {
            var vm = this;
            this.$store.dispatch({
                type: 'workOrder/getGetReturnVisit',
                id: this.workOrderId
            }).then(() => {
                vm.returnVisits = vm.$store.state.workOrder.returnVisits;
                var arr = vm.returnVisits.filter(x => x.score === 1);
                vm.tuiDanNum = arr.length;
            });
        },
        show() {
            this.returnVisitDto = {
                name: this.workOrderInfo.name,
                mobile: this.workOrderInfo.mobile,
                file: {}
            };
            this.showReturnVisitModel = true;
        }
    },
    created() {
        // this.getReturnVisits();
    },
    watch: {
        // workOrderId() {
        //     if (this.workOrderId > 0) {
        //         this.getReturnVisits();
        //     }
        // }
    }
};
